import AmexGDAB2BTestimonialsCarousel from './AmexGDAB2BTestimonialsCarousel';

export default AmexGDAB2BTestimonialsCarousel;
